import type { SchedulingMethod } from '@/features/products/types/products.types';

/**
 * NOT load-bearing for every resumed quote: only quotes persisted before the frozen product
 * blob began carrying schedulingMethods ever reach these retired customer-facing names.
 */
const RETIRED_METHOD_LABELS: ReadonlyMap<string, string> = new Map([
    ['deposit_plus_even', 'Balanced with Deposit'],
    ['item_based_with_deposit', 'Variable with Deposit'],
]);

export const schedulingMethodLabel = (
    methods: SchedulingMethod[] | undefined,
    methodKey: string,
): string =>
    methods?.find((m) => m.key === methodKey)?.label
    ?? RETIRED_METHOD_LABELS.get(methodKey)
    ?? methodKey;
